import React, {useState, useEffect} from 'react';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function UserCreateTeamCard({show_display}) 
{
    const { app_user, setUserDisplayRefresh } = useCTAL();
    
    const [error, setError] = useState();
    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [create_team_button_type, setCreateTeamButtonType] = useState("btn btn-sm btn-secondary mt-2");
    const [results_display, setResultsDisplay] = useState(<></>); 
    
    useEffect(() =>
    {
        if (DEBUG) console.log(`UserCreateTeamCard - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag)
            setCreateTeamButtonType("btn btn-sm btn-secondary mt-2");
        else
            setCreateTeamButtonType("btn btn-sm btn-primary mt-2");
    }, [form_changed_flag]);

    const reset_results = () => { setResultsDisplay(<></>); }
    const prepend_result = (result) => { setResultsDisplay( <> {result} {results_display} </>) }

    const create_result_success  = (message) => { return <div class="alert alert-success my-1 py-0" role="alert"><small>{message}</small></div>; }
    const create_result_error    = (message) => { return <div class="alert alert-danger  my-1 py-0" role="alert"><small>{message}</small></div>; }

    const handle_response = (res) => { 

        if (DEBUG) console.log(`UserCreateTeamCard - res.message: ${res.message}`);

        switch (res.result)
        {
            case "success"          : prepend_result(create_result_success(res.message)); setUserDisplayRefresh(true); break;
            case "error"            : prepend_result(create_result_error(res.message));    break;
            default: break;
        }
    }

    const create_team = (set_body) => { 
        console.log(`UserCreateTeamCard - Create Team set_body: ${set_body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-set`, { method: "POST", body: set_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: set_body })
            .then(response => response.json())
            .then(handle_response)
            .catch(setError);
    }

    const create_team_request = () => { 
        if (!form_changed_flag) return;

        var team_name = document.getElementById("create-team-name").value;

        if (team_name == "") { setFormChangedFlag(false); return; } //Team Name cannot be empty

        var type = "create_team";
        var user_id = app_user.UserID;
        var user_name = app_user.UserName;
        var user_full_name = app_user.UserFullName;
        var action_item_id_prefix = document.getElementById("create-team-prefix").value;
        var is_private = false;
        var team_desc = document.getElementById("team-desc-input").value;
        var body = JSON.stringify({type, team_name, user_id, user_name, user_full_name, action_item_id_prefix, is_private, team_desc});

        create_team(body);

        document.getElementById("create-team-name").value = "";
        document.getElementById("team-desc-input").value = "";
        document.getElementById("create-team-prefix").value = "";

        setFormChangedFlag(false);
    }
    
    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    return (
        <div class="card mt-2">
            <div id="create-team-card-header" class="card-header">
                <div class="row">
                    <div class="col text-start">
                        <a href="#"><img class="card-icon" src="./images/add.svg" alt="history" border="0"/></a>
                        <span className="card-sub-title">Create Team</span>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="input-group input-group-sm" required>
                    <span class="input-group-text" >Name</span>
                    <input id="create-team-name" type="text" class="form-control" placeholder="New Team Name" aria-label="TeamName" aria-describedby="create-team" onChange={form_changed}/>
                </div>
                <div class="form-floating mt-1">
                    <textarea id="team-desc-input" class="form-control" placeholder="New Team Description"></textarea>
                    <label class="select-floating-label" htmlFor="floatingSelect">New Team Description</label>
                </div>
                <div class="input-group input-group-sm mt-1">
                    <span class="input-group-text" >Prefix</span>
                    <input id="create-team-prefix" type="text" class="form-control" placeholder="Action Prefix (1-4 letters)" aria-label="TeamPrefix" aria-describedby="create-team-ai-prefix"/>
                </div>
                <div class="row">
                    <div class="col text-end">                      
                        <a href="#" class={create_team_button_type} onClick={ () => create_team_request() }>Create Team</a>
                    </div>
                </div>
                
                {results_display}

            </div>
        </div>
    );
}

